export default "__VITE_ASSET___B1JgYog__";